export default {
	title: "Utilisateurs",
	email: "E-mail",
	createdAt: "Créé le",
	totalUsers: "Total des utilisateurs",
	adminUsers: "Administrateurs",
	confirmRemove: "Confirmer la suppression",
	confirmRemoveMessage: "Êtes-vous sûr de vouloir retirer {name} du temple ?",
	displayName: "Nom",
	inviteUser: "Inviter un utilisateur",
	memberUsers: "Membres",
	ownerUsers: "Propriétaires",
	removeError: "Erreur lors de la suppression de l'utilisateur",
	removeSuccess: "Utilisateur supprimé avec succès",
	ritualFunction: "Fonction rituelle",
	role: "Rôle",
	roleChangeError: "Erreur lors du changement de rôle",
	roleChangeSuccess: "Rôle mis à jour avec succès",
};
